<template>
    <q-tab-panel name="EventNoticeboardTab">
        <div class="text-center q-mt-xl">
        <q-btn outline color="secondary" :label="ts( 'noticeboardOnWeb')" @click="noticeboardOpen"></q-btn>
        </div>
    </q-tab-panel>
</template>

<script setup lang="ts">
import { ts } from "@/plugins/i18n-formatted"
import EventsRepo from "@repo/EventsRepo"
import { useRepo } from "pinia-orm"
import { computed } from "vue"
import { useRoute } from "vue-router"

const route = useRoute()
const event = computed( () => ( useRepo( EventsRepo ).getEvent( String( route.params.eventId ), true ) ) )

useRepo( EventsRepo ).selectEvent( event.value?.id )

function noticeboardOpen () {
    window.open('http://www.sailing.cz/noticeboard/' + event.value.ctlId, '_blank' )
}
</script>